const AFFILIATE_URL = "https://bc072hg2p7rncg20qs5ev03po2.hop.clickbank.net";

export const ScientificReferences = () => {
  return (
    <section data-testid="references-section" className="py-8 md:py-12 bg-[#1A1C19]" aria-labelledby="references-heading">
      <a 
        href={AFFILIATE_URL} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="block cursor-pointer hover:opacity-90 transition-opacity"
      >
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 id="references-heading" className="sr-only">Scientific References</h2>
          <img
            src="https://customer-assets.emergentagent.com/job_orange-peel-sales/artifacts/zjaaeau9_Screenshot%202026-02-06%20221405.png"
            alt="Scientific References - Clinical studies supporting the Orange Peel Trick ingredients including Citrus Aurantium, Green Tea Extract, Capsaicin Complex, and Ginger Root for metabolism and weight loss support"
            className="w-full h-auto rounded-lg shadow-lg border border-[#FF6B00]/20"
            loading="lazy"
          />
        </div>
      </a>
    </section>
  );
};

export default ScientificReferences;
